// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs_tabs__bB9e5","sm":"tabs_sm__Avnnu","md":"tabs_md__b9P7e","lg":"tabs_lg__g9iAs","tabButton":"tabs_tabButton__qb4ok","selected":"tabs_selected___PWKS"};